import {
    EErrorResponseCode,
    EReceiptCompleteType,
    EAuditStatus,
    EAuditType,
    EProjectItemType,
    EWorkflowType,
    EWorkflowStepStatus,
    EProjectStatus,
    ESearchMode
} from './enums';

export default {
    EErrorResponseCode: EErrorResponseCode,
    EReceiptCompleteType: EReceiptCompleteType,
    EAuditStatus: EAuditStatus,
    EAuditType: EAuditType,
    EProjectItemType: EProjectItemType,
    EWorkflowType: EWorkflowType,
    EWorkflowStepStatus: EWorkflowStepStatus,
    EProjectStatus: EProjectStatus,
    ESearchMode: ESearchMode,
};
